import React from "react";
import { Badge } from "react-bootstrap";

interface IAiRunFilterChip {
    aiRunId: string;
    onClear: () => void;
}

export const AiRunFilterChip = ({ aiRunId, onClear }: IAiRunFilterChip) => {
    if (!aiRunId) {
        return null;
    }
    return (
        <div className="mb-2">
            <Badge variant="info" className="mr-2">
                Filter: KI-Import #{aiRunId}
            </Badge>
            <button type="button" className="btn btn-link btn-sm p-0" onClick={onClear}>
                Filter entfernen
            </button>
        </div>
    );
};

export default AiRunFilterChip;
